import '../chunk-AV47546M.js';
import { a } from '../chunk-IMSWER4T.js';

var o=class{_client=a.instance;async validateSso(e){await this._client.post("/sso/validate",e);}};

export { o as SsoRestService };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map